import { render } from "./BillingsMainPage.vue?vue&type=template&id=c27d49b8"
import script from "./BillingsMainPage.vue?vue&type=script&lang=js"
export * from "./BillingsMainPage.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__